/**
 * @file High level controller for the response file generating states.
 * This component loads the states corresponding to specific installation the user chose
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import React, { Component } from 'react';
import ConfigurationContent from '../../../Components/ConfigurationContent/ConfigurationContent';
import { states as winStates } from '../../../Utils/WindowsDataLoader';
import { states as linStates } from '../../../Utils/LinuxDataLoader';
import { loadData } from '../../../Utils/DataLoader';
import * as DEFINITIONS from '../../../Utils/Constants';
class InstallationOsControl extends Component {
    //Load states
    constructor(props) {
        super(props);
        switch (props.useOs) {
            case DEFINITIONS.LINUX:
                switch (props.useVersion) {
                    case DEFINITIONS.M11_6_09:
                        loadData(DEFINITIONS.LINUX_11_6_09);
                        break;
                    case DEFINITIONS.M11_6_06:
                        loadData(DEFINITIONS.LINUX_11_6_06);
                        break;
                    case DEFINITIONS.M11_6_03:
                        loadData(DEFINITIONS.LINUX_11_6_03);
                        break;
                    case DEFINITIONS.M11_5_12:
                        loadData(DEFINITIONS.LINUX_11_5_12);
                        break;
                    case DEFINITIONS.M11_5_09:
                        loadData(DEFINITIONS.LINUX_11_5_09);
                        break;
                    case DEFINITIONS.M11_5_06:
                        loadData(DEFINITIONS.LINUX_11_5_06);
                        break;
                    case DEFINITIONS.M11_5_03:
                        loadData(DEFINITIONS.LINUX_11_5_03);
                        break;
                    case DEFINITIONS.M11_4_12:
                        loadData(DEFINITIONS.LINUX_11_4_12);
                        break;
                    default:
                }
                this.state = linStates;
                break;
            case DEFINITIONS.WINDOWS:
                switch (props.useVersion) {
                    case DEFINITIONS.M11_6_09:
                        switch (props.useMode) {
                            case DEFINITIONS.CUSTOM_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_6_09_CUSTOM);
                                break;
                            case DEFINITIONS.EXPRESS_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_6_09_EXPRESS);
                                break;
                            default:
                        }
                        break;
                    case DEFINITIONS.M11_6_06:
                        switch (props.useMode) {
                            case DEFINITIONS.CUSTOM_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_6_06_CUSTOM);
                                break;
                            case DEFINITIONS.EXPRESS_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_6_06_EXPRESS);
                                break;
                            default:
                        }
                        break;
                    case DEFINITIONS.M11_6_03:
                        switch (props.useMode) {
                            case DEFINITIONS.CUSTOM_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_6_03_CUSTOM);
                                break;
                            case DEFINITIONS.EXPRESS_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_6_03_EXPRESS);
                                break;
                            default:
                        }
                        break;
                    case DEFINITIONS.M11_5_12:
                        switch (props.useMode) {
                            case DEFINITIONS.CUSTOM_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_5_12_CUSTOM);
                                break;
                            case DEFINITIONS.EXPRESS_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_5_12_EXPRESS);
                                break;
                            default:
                        }
                        break;
                    case DEFINITIONS.M11_5_09:
                        switch (props.useMode) {
                            case DEFINITIONS.CUSTOM_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_5_09_CUSTOM);
                                break;
                            case DEFINITIONS.EXPRESS_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_5_09_EXPRESS);
                                break;
                            default:
                        }
                        break;
                    case DEFINITIONS.M11_5_06:
                        switch (props.useMode) {
                            case DEFINITIONS.CUSTOM_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_5_06_CUSTOM);
                                break;
                            case DEFINITIONS.EXPRESS_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_5_06_EXPRESS);
                                break;
                            default:
                        }
                        break;
                    case DEFINITIONS.M11_5_03:
                        switch (props.useMode) {
                            case DEFINITIONS.CUSTOM_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_5_03_CUSTOM);
                                break;
                            case DEFINITIONS.EXPRESS_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_5_03_EXPRESS);
                                break;
                            default:
                        }
                        break;
                    case DEFINITIONS.M11_4_12:
                        switch (props.useMode) {
                            case DEFINITIONS.CUSTOM_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_4_12_CUSTOM);
                                break;
                            case DEFINITIONS.EXPRESS_INSTALL:
                                loadData(DEFINITIONS.WINDOWS_11_4_12_EXPRESS);
                                break;
                            default:
                        }
                        break;
                }
                this.state = winStates;
                break;
            default:
        }
    }

    /**
     * change the 'steps' state to control the page display.
     * deepestStep is related to Navigation Sidebar and it should always be the maximum step number that has been went through.
     */
    nextStep = () => {
        if (this.state.deepestStep > this.state.steps) {
            this.setState((preState, props) => {
                return {
                    steps: preState.steps + 1,
                };
            });
        } else {
            this.setState((preState, props) => {
                return {
                    steps: preState.steps + 1,
                    deepestStep: preState.steps + 1,
                };
            });
        }
    };

    /**
     * Go back for one step.
     */
    backStep = () => {
        if (this.state.steps > 0) {
            this.setState((preState, props) => {
                return {
                    steps: preState.steps - 1,
                };
            });
        }
    };
    /**
     * Get the value of a specific state
     * @param {String} key the state field
     * @return {Object} the value of the state
     */
    getOriginState = (key) => {
        if (Object.keys(this.state).includes(key)) {
            return this.state[key];
        }
        return null;
    };

    /**
     * Change the value of a specific state
     * @param {String} key the state field
     * @param {Object} value the new value of the state you want to set
     */
    setOriginState = (key, value) => {
        if (Object.keys(this.state).includes(key)) {
            this.setState({
                [key]: value,
            });
        }
    };

    render() {
        return (
            <ConfigurationContent
                nextStep={this.nextStep}
                backStep={this.backStep}
                useOs={this.props.useOs}
                useMode={this.props.useMode}
                useVersion={this.props.useVersion}
                setOriginState={this.setOriginState}
                getOriginState={this.getOriginState}
                steps={this.state.steps}
                setBasicState={this.props.setBasicState}
                deepestStep={this.state.deepestStep}
            />
        );
    }
}

export default InstallationOsControl;
